<!-- cv-rl List -->
<template>
  <div class="cv-rl-item">
    <div>
      <div class="cv-rl-item-title">
        <zlr-title :title="title"></zlr-title>
      </div>
      <ul class="cv-rl-item-ul">
        <li v-for="(emItem, emIndex) in data.emEdit"
            :key="'em'+emIndex">
          <zlr-card-simple title="EM Edit"
                           :avatar="emItem.mentorHead || MentorAvatar"
                           :circleSign="emItem | filterColor"
                           :con="emItem.status === 'NOTEDIT'? `<span style='font-size:12px;display: inline-block;line-height: 18px;margin-top: 12px;'>(${emItem.timeZone}) ${emItem.deadlineTime} Edit turnaround DDL</span>`:'' ">
            <a class="blue"
               @click="handleDownlod(emItem.menteeEdit)"
               v-if="userRole === 'EM' && emItem.status === 'NOTEDIT'">Download</a>
            <a class="blue"
               @click="handleUpload(data.id, emItem.id, emItem.jointId)"
               v-if="userRole === 'EM' && emItem.status === 'NOTEDIT' ">Upload</a>
            <a class="blue"
               style="position:relative;z-index:101"
               v-if="userRole === 'EM' && emItem.status === 'EDITED' "
               @click="handleFeedback(emItem.mentorEdit)">Feedback</a>
          </zlr-card-simple>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
// api
import { ossSecretLink, downFile } from '@/api/oss'
// images
import MentorAvatar from '@/assets/images/home/mentor-avatar.svg'
// components
import ZlrCardSimple from '_c/card-simple/card-simple'
import ZlrTitle from '_c/title/title'
import { mapState } from 'vuex'
export default {
  name: 'mentee-cl-rl-list',
  components: {
    ZlrCardSimple,
    ZlrTitle
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default () {
        return {
          emEdit: []
        }
      }
    }
  },
  data () {
    return {
      MentorAvatar
    }
  },
  computed: {
    ...mapState({
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () { },
  methods: {
    // 下载
    handleDownlod ({ url, fileName }) {
      ossSecretLink({
        dir: url
      }).then(res => {
        this.downFile(res.data.url, fileName)
      })
    },
    // 下载二进制文件
    downFile (url, filename) {
      downFile({
        filename,
        url
      })
    },
    // 上传
    handleUpload (id, itemId, jointId) {
      this.$emit('on-upload', {
        id,
        itemId,
        jointId,
        type: 'EMEDIT'
      })
    },
    // feedback
    handleFeedback (data) {
      this.$emit('on-feedback', data)
    }
  },
  filters: {
    filterColor (item) {
      let color = ''
      if (item.status === 'EDITED') {
        color = 'green'
      } else if (item.status === 'NOTEDIT') {
        color = 'orange'
      }
      return color
    }
  }
}
</script>
<style lang='less' scoped>
</style>
